import React, { useRef, useEffect } from "react";

export const IntersectionObserverComponent = ({
  display = "",
  onEnterViewport,
  onExitViewport,
  doOnce,
}) => {
  const intersectionObserverRef = useRef();
  const triggeredCount = useRef(0); // will update when intersectionObserverRef comes into the viewport
  const hasTriggered = useRef(false); //flag to stop it from triggering continuously
  useEffect(() => {
    let observer = new IntersectionObserver(([observerEntry]) => {
      //   console.log(observerEntry);
      if (observerEntry.isIntersecting) {
        // console.log(hasTriggered.current);
        if (!(doOnce && triggeredCount.current > 0) && !hasTriggered.current) {
          //   console.log("Is intersecting");
          onEnterViewport && onEnterViewport();
          hasTriggered.current = true;
        }
        triggeredCount.current++;
      }
      //if we got here it means we scrolled away from end after having been there (Using triggeredCount to avoid running this when first rendering the page)
      if (
        !observerEntry.isIntersecting && //this is true on first render or if the element left the view
        triggeredCount.current > 0 && // to avoid triggering on first render
        !(doOnce && triggeredCount.current > 1) //if it is doOnce, only do once. Using 1 here because:
      ) {
        //if trigger count is greater than 1, i.e. 2 or more. We have previously scrolled to the end, left, and scrolled back.
        onExitViewport && onExitViewport();
        // console.log("exited");
        hasTriggered.current = false;
      }
    });
    observer.observe(intersectionObserverRef.current);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [display, onEnterViewport, onExitViewport, doOnce]);
  return (
    <div ref={intersectionObserverRef} style={{ minHeight: "1px" }}>
      {display}
    </div>
  );
};
